import apiDocuments from '@/api/documents'

const state = {
  data: [],
  total: null,
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getDocumentsByParamsStart: '[documents] Get documents by params start',
  getDocumentsByParamsSuccess: '[documents] Get documents by params success',
  getDocumentsByParamsFailure: '[documents] Get documents by params failure',
}

export const actionTypes = {
  getDocumentsByParams: '[documents] Get documents by params',
}

const mutations = {
  [mutationTypes.getDocumentsByParamsStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getDocumentsByParamsSuccess](state, payload) {
    state.data = payload.data ? payload.data : payload
    state.total = payload.total ? Number(payload.total) : 0
    state.isLoading = false
  },

  [mutationTypes.getDocumentsByParamsFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getDocumentsByParams](context, {athleteId, params}) {
    context.commit(mutationTypes.getDocumentsByParamsStart)
    return new Promise((resolve) => {
      apiDocuments
        .getAthleteDocuments(athleteId, params)
        .then((response) => {
          context.commit(mutationTypes.getDocumentsByParamsSuccess, response)
          resolve(response)
        })
        .catch(() => {
          context.commit(mutationTypes.getDocumentsByParamsFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
